import React, {memo, useMemo} from 'react'
import {Collapse} from '@material-ui/core';
import PropTypes from 'prop-types';
import ElementTitle from './ElementTitle';
import PartForm from './PartForm'
import removeFormikListElement from 'libs/removeFormikListElement';
import getObjectValue from 'libs/getObjectValue';
import {withRouter} from "react-router";
import {connect} from 'react-redux'
import {addObjectResource, setResource} from 'redux/actions'
import {wasEverPublished, isNationalProcedure, isEuropeProcedure} from "libs/getDemandStatus";

function Element({
                     index,
                     id,
                     formikProps,
                     match,
                     dealing,
                     addObjectResource,
                     dealingsList,
                     dirtyListenerSemaphore,
                     demandHeader,
                     autoSaveFormDraftActive
                 }) {
    const partId = `${id}.${index}`
    const createId = key => `${partId}.${key}`

    const elements = getObjectValue(id, formikProps.values, []);
    const elementsLength = elements.length;
    const isPublished = useMemo(() => demandHeader ? wasEverPublished() : undefined, [demandHeader]);
    const isPublic = useMemo(() => demandHeader ? isNationalProcedure() || isEuropeProcedure() : undefined, [demandHeader]);

    const open = getObjectValue(createId('_open'), formikProps.values)
    const setOpen = (value) => {
        dirtyListenerSemaphore.current = true;
        formikProps.setFieldValue(createId('_open'), value)
        if (value === true) {
            formikProps.setFieldValue(createId('_touched'), true)
        }
        dirtyListenerSemaphore.current = false;
    }
    const elementId = getObjectValue(createId('identity'), formikProps.values)

    const handleDelete = () => {
        //DealingsService.autoSaveDeleteSingle(demendId, index).then(() => {
        addObjectResource('dealing', elementId)
        removeFormikListElement(formikProps, id, index)
        //})
    }

    let isDealingElement = dealing ? dealing[elementId] ? true : false : false;

    // const stageCriterions = getObjectValue(createId('stages.0.criterions'), formikProps.values)
    // useEffect(() => {
    // 	let value = sumCriteria(stageCriterions)
    // 	//formikProps.setFieldValue(createId('_criteriaSum'), value.toFixed(2))
    // 	// formikProps.setFieldTouched(createId('_criteriaSum'), false)
    // 	//eslint-disable-next-line
    // }, [stageCriterions])

    const renderForm = () => {
        if (open) {
            return (
                <PartForm
                    id={partId}
                    formikProps={formikProps}
                    isDealingElement={isDealingElement}
                    dealingsList={dealingsList}
                    dirtyListenerSemaphore={dirtyListenerSemaphore}
                    autoSaveFormDraftActive={autoSaveFormDraftActive}
                />
            )
        }
        return ''
    }

    return (
        <>
            <ElementTitle
                id={partId}
                index={index}
                formikProps={formikProps}
                open={open}
                onOpen={() => setOpen(!open)}
                onDelete={handleDelete}
                disableDelete={elementsLength < 2 || (isPublic && isPublished)}
            />

            <Collapse in={open}>
                {renderForm()}
            </Collapse>
        </>
    )
}

Element.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    dealing: state.resources.dealing,
    dealingsList: state.resources.dealingsList,
    demandHeader: state.resources.demandHeader
}), {
    setResource,
    addObjectResource,
})(withRouter(memo(Element, (prevProps, nextProps) => {
    if (prevProps.id !== nextProps.id) return false;
    if (prevProps.index !== nextProps.index) return false;
    if (JSON.stringify(prevProps.classes) !== JSON.stringify(nextProps.classes)) return false;
    const partId = nextProps.id + '.' + nextProps.index;
    if (JSON.stringify(prevProps.formikProps.values) !==
        JSON.stringify(nextProps.formikProps.values)
    ) return false;
    if (JSON.stringify(getObjectValue(partId, prevProps.formikProps.errors)) !==
        JSON.stringify(getObjectValue(partId, nextProps.formikProps.errors))
    ) return false;
    if (JSON.stringify(getObjectValue(partId, prevProps.formikProps.touched)) !==
        JSON.stringify(getObjectValue(partId, nextProps.formikProps.touched))
    ) return false;
    if (prevProps.dealing !== nextProps.dealing)
        return false;
    if (prevProps.dealing &&
        nextProps.dealing &&
        JSON.stringify(Object.keys(prevProps.dealing)) !==
        JSON.stringify(Object.keys(nextProps.dealing))
    ) return false;
    // history
    // staticContextx
    // location
    // match
    return true;
})));